import Heading from '@/components/heading/Heading';
import Padding from '@/components/padding/Padding';
import Footer from '@/pages/home/components/Footer';
import {
  Box,
  Flex,
  Heading as ChakraHeading,
  Link,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const OAuthSuccess = (): React.JSX.Element => {
  return (
    <Flex direction="column" minH="100vh">
      <Heading />
      <Flex
        as="main"
        id="main-content"
        role="main"
        tabIndex={-1}
        flex="1"
        align="center"
        justify="center"
      >
        <Padding verticalPadding={12}>
          <Box textAlign="center" maxW="2xl" mx="auto">
            <ChakraHeading
              as="h1"
              fontSize={{ base: '4xl', md: '5xl' }}
              style={{ fontFamily: 'Bebas Neue' }}
              mb={4}
            >
              Instagram connected
            </ChakraHeading>
            <Text
              fontSize={{ base: 'md', md: 'lg' }}
              style={{ fontFamily: 'Lato' }}
              lineHeight="1.7"
              mb={8}
            >
              You can close this window and return to Olympiq.
            </Text>
            <Link
              asChild
              color="blue.600"
              _dark={{ color: 'blue.300' }}
              textDecoration="underline"
              style={{ fontFamily: 'Lato' }}
            >
              <RouterLink to="/">Back to Olympiq</RouterLink>
            </Link>
          </Box>
        </Padding>
      </Flex>
      <Footer />
    </Flex>
  );
};

export default OAuthSuccess;
